 import { EnvService as service } from '../sharedBase/env.service';
//import { EnvService as service } from '@ojas-enterprise/baseapp/dist/sharedBase';

export class EnvService extends service {

}
